
export enum EPricingItemMenuActions {
  EDIT = 'EDIT',
  DUPLICATE = 'DUPLICATE',
  CLEAR_CONTENT = 'CLEAR_CONTENT',
  MOVE_UP = 'MOVE_UP',
  MOVE_DOWN = 'MOVE_DOWN',
  DELETE = 'DELETE',
}
